module.exports = "build/assets/RingsideRegular-Light.4d1a7d93.woff2";